import styles from './Sobre.module.scss'
import fotoFrancis from '../../assets/images/optimized/sobre-francis.webp'

const CREDENTIALS = [
  'Fonoaudióloga | CRFa 8-12521',
  'Atendimento online para crianças, adolescentes e adultos',
  'Formação contínua e atualização constante',
]

const Sobre = () => (
  <section id="sobre" className={styles.section}>
    <div className={styles.inner}>
      <div className={styles.media}>
        <img
          src={fotoFrancis}
          alt="Fga. Francis Guimarães"
          width={910}
          height={1280}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={styles.content}>
        <p className={styles.kicker}>Sobre mim</p>
        <h2>
          Prazer, sou <span>Francis Guimarães</span>
        </h2>
        <p className={styles.bio}>
          Sou fonoaudióloga com 6 anos de experiência e acredito que a
          comunicação é uma das principais formas de conexão humana.
        </p>
        <p className={styles.bio}>
          À frente da Minha Fono Online, lidero uma equipe de fonoaudiólogos
          dedicada a oferecer um atendimento personalizado, baseado em avaliação
          individual e estratégias específicas para cada paciente, sempre com
          acolhimento, ética e ciência.
        </p>

        <ul className={styles.credentials}>
          {CREDENTIALS.map(item => (
            <li key={item}>
              <i className="material-icons">check_circle</i>
              {item}
            </li>
          ))}
        </ul>

        <div className={styles.quote}>
          <i className="material-icons">format_quote</i>
          <p>
            A voz é a chave que abre a porta do mundo
            <br />
            para quem se sente preso do lado de dentro.
          </p>
        </div>
      </div>
    </div>
  </section>
)

export default Sobre
